import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import localeEn from '@angular/common/locales/en';
import localeNl from '@angular/common/locales/nl';
import localePt from '@angular/common/locales/pt';
import localeEs from '@angular/common/locales/es';
import { AppComponent } from './app.component';
import { RoutingModule } from './routing.module';
import { LoginModule } from './shared/components/login/login.module';
import { RightsService } from './shared/services/rights/rights.service';
import { ViewService } from "./shared/services/views/view.service";
import { UIModule } from 'libraries/ui/ui.module';
import { FormService } from 'libraries/service/form/form.service';
import { BreadcrumbServiceModule } from 'libraries/service/breadcrumb/breadcrumbService.module';
import { ConfigurationResourceModule } from 'libraries/service/resources/configuration/configurationResource.module';
import { PermissionModule } from "libraries/permission/permission.module";
import { AppNavModule } from './shared/components/nav/nav.module';
import { TabNavigationModule } from 'libraries/component/tab-navigation/tab-navigation.module';
import { CardModule } from 'libraries/ui_card/card.module';
import { AuthModule } from 'libraries/service/auth/auth.module';
import { WuiErrorHandlerService } from "libraries/service/error-tracing/wui-error-handler.service";
import { PermissionResourceModule } from 'libraries/service/resources/permission/permissionResource.module';
import { AppHeaderModule } from './shared/components/app-header/app-header.module';
import { getUserLanguage } from "libraries/service/language/language.service";

registerLocaleData(localeFr);
registerLocaleData(localeIt);
registerLocaleData(localeEn);
registerLocaleData(localeNl);
registerLocaleData(localePt);
registerLocaleData(localeEs);

@NgModule({
    imports: [
        BrowserModule,
        NoopAnimationsModule,
        FormsModule,
        RoutingModule,
        AuthModule,
        HttpClientModule,
        HttpClientJsonpModule,
        UIModule,
        CardModule,
        // We need to declare it there in order to be able to share state
        // between multiple routes in the service
        BreadcrumbServiceModule,
        // ConfigurationResourceService is caching results,
        // In order for it to work properly between routes,
        // we need to load it here
        ConfigurationResourceModule,
        LoginModule,
        PermissionModule,
        AppNavModule,
        TabNavigationModule,
        PermissionResourceModule,
        AppHeaderModule,
    ],
    declarations: [
        AppComponent,
    ],
    bootstrap: [
        AppComponent
    ],
    providers: [
        RightsService,
        ViewService,
        FormService,
        { provide: LOCALE_ID, useValue: getUserLanguage() },
        { provide: ErrorHandler, useClass: WuiErrorHandlerService },
    ],
    exports: [
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
